import styled from '@emotion/styled';
import { borderRadius, colors, spacing, typography } from '@/lib/design-tokens';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  gap: ${spacing[300]};
  text-align: center;
  padding: ${spacing[500]};
`;

const ErrorCode = styled.h1`
  font-size: 96px;
  font-weight: ${typography.fontWeight.bold};
  color: ${colors.neutral[1000]};
  margin: 0;
  line-height: 1;
`;

const Message = styled.p`
  font-size: ${typography.fontSize.h600};
  color: ${colors.neutral[700]};
  margin: 0;
`;

const BackLink = styled.a`
  display: inline-block;
  margin-top: ${spacing[200]};
  padding: 10px 20px;
  background-color: ${colors.brand.blue[600]};
  color: ${colors.neutral[0]};
  border-radius: ${borderRadius.default};
  font-family: ${typography.fontFamily.default};
  font-size: ${typography.fontSize.body};
  font-weight: ${typography.fontWeight.medium};
  text-decoration: none;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${colors.brand.blue[700]};
  }

  &:focus-visible {
    outline: 2px solid ${colors.brand.blue[300]};
    outline-offset: 2px;
  }
`;

function NotFoundPage() {
  return (
    <Container>
      <ErrorCode>404</ErrorCode>
      <Message>ページが見つかりません</Message>
      <BackLink href="/dashboard">ダッシュボードへ戻る</BackLink>
    </Container>
  );
}

export { NotFoundPage };
